export default function Footer() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const footerLinks = [
    {
      title: '快速导航',
      links: [
        { label: '主题导航', href: '#index' },
        { label: '热度榜单', href: '#ranking' },
        { label: '精选视频', href: '#media' },
        { label: '精彩推荐', href: '#cards' },
        { label: '焦点专题', href: '#carousel' },
      ],
    },
    {
      title: '关于平台',
      links: [
        { label: '关于我们', href: '#about' },
        { label: '联系我们', href: '#contact' },
        { label: '常见问题', href: '#faq' },
        { label: '最新动态', href: '#updates' },
        { label: '移动端入口', href: '#app' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
      isPartner: true,
    },
  ];

  return (
    <footer id="footer" className="bg-foreground-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="text-xl font-heading font-bold text-white">今日看料</span>
            <p className="mt-3 text-sm leading-relaxed text-foreground-400">
              今日看料官网——一站式内容聚合与导航平台。提供最新官方地址与首页入口，
              覆盖影视娱乐、知识科普、动漫番剧等多元频道，每日更新精选内容，助你发现精彩世界。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-bold text-white mb-3">{group.title}</h3>
              {group.isPartner ? (
                <p className="text-xs text-foreground-500 leading-relaxed">
                  合作伙伴信息即将上线，敬请期待。
                </p>
              ) : (
                <ul className="space-y-2">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => { e.preventDefault(); handleScroll(link.href); }}
                        className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2017-2026 今日看料官网 All Rights Reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span className="cursor-default">隐私政策</span>
            <span className="cursor-default">服务条款</span>
            <span className="cursor-default">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}